import { ConfigEntry } from "@TXQueries";
import { AxiosResponse } from "axios";
import { makeAutoObservable, runInAction } from "mobx";

import RootContext from "@client/context/RootContext";
import { QueryStoreConfigReturn } from "@server/data/magento/mage-config-store.data";

export const CONFIG_KEYS: Record<string, string> = {
	NOTIFICATION_ENABLED: "s2s/reminder/enabled",
	NOTIFICATION_MESSAGE: "s2s/reminder/message",
	NOTIFICATION_TITLE: "s2s/reminder/title",

	DASHBOARD_ENABLE: "s2s/dashboard/enable",

	PICKUP_POPUP: "s2s/general/pickup_popup",
	PICKUP_POPUP_HOUR: "s2s/general/pickup_popup_hour",
	PICKUP_POPUP_ENABLE: "s2s/general/pickup_popup_enable",

	VENDOR_REPORT_EMAILS: "s2s/vendor_alerts/enabled",
};

export class ConfigStore {
	keys: ConfigEntry[] = [];

	isConfigStoreLoaded = false;

	constructor(private rootContext: RootContext) {
		makeAutoObservable(this);

		this.loadData();
	}

	loadData = async () => {
		try {
			const data: AxiosResponse<QueryStoreConfigReturn> =
				await this.rootContext.apiService.get("/api/config-data");
			if (data) {
				runInAction(() => {
					this.keys = data.data.configValue;
				});
			}
		} catch (e) {
			console.log("Error loading config store", e);
		}

		runInAction(() => {
			this.isConfigStoreLoaded = true;

			this.rootContext.layoutStore.setisDashboardActive(
				this.getConfigValue(CONFIG_KEYS.DASHBOARD_ENABLE) === "1"
			);
		});
	};

	getConfigValue = (key: string) => {
		return this.keys.find((k) => k.path === key)?.value || "0";
	};
}
